import { AuthProvider, ProtectRoute } from './AuthContext';

const AppContext = ({ children }: { children: React.ReactNode }) => (
  <AuthProvider>
    <ProtectRoute>{children}</ProtectRoute>
  </AuthProvider>
);
export default AppContext;
